import {
  deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId,
  getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';

type Options = {
  onSuccess?: () => void;
  onError?: () => void;
};

/**
 * ポータル削除 API を実行するカスタムフック
 *
 * @param threeLetterCode - クライアントコード
 * @param options - コールバックオプション
 */
export const useDeletePortal = (threeLetterCode: string, options?: Options) =>
  useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsClientPortalItemsMutationKey(threeLetterCode),
    (_, { arg }: { arg: number }) =>
      deleteApiV1ThreeLetterCodeClientAdminsClientPortalItemsId(threeLetterCode, arg),
    options
  );
